/*
 *
 * FloatingDownloadTileContainer
 *
 * @version 1.0.0
 * @author System
 * @since 2024
*/

import { connect } from 'react-redux'
import React from 'react'
import FloatingDownloadTile from './FloatingDownloadTile'
import { nullSafe } from 'Utility/globalMethods'
import { Document, ArrowDownload } from '@nexidigital/iconlibrary'

const mapStateToProps = state => ({
  title: nullSafe(() => state.floating.floatingInfo.title, ''),
  subtitle: nullSafe(() => state.floating.floatingInfo.subtitle, ''),
  downloadIcon: nullSafe(() => state.floating.floatingInfo.downloadIcon, <ArrowDownload size='24' type='line' />),
  iconDocument: nullSafe(() => state.floating.floatingInfo.iconDocument, <Document size='24' type='line' />),
  loading: nullSafe(() => state.floating.floatingInfo.loading, false),
  processing: nullSafe(() => state.floating.floatingInfo.processing, false),
  onClickDownload: nullSafe(() => state.floating.floatingInfo.onClickDownload, null),
  onClickDownloadAction: nullSafe(() => state.floating.floatingInfo.onClickDownloadAction, null)
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onClickDownload: () => {
    if (stateProps.onClickDownloadAction) {
      dispatchProps.dispatch(stateProps.onClickDownloadAction)
    } else if (stateProps.onClickDownload && typeof stateProps.onClickDownload === 'function') {
      stateProps.onClickDownload()
    }
  }
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FloatingDownloadTile)
